import { render, staticRenderFns } from "./soloCalProviders.vue?vue&type=template&id=5db09955"
import script from "./soloCalProviders.vue?vue&type=script&lang=js"
export * from "./soloCalProviders.vue?vue&type=script&lang=js"
import style0 from "./soloCalProviders.vue?vue&type=style&index=0&id=5db09955&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports